// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2490":"0428f24f98da70a6","4112":"a3ede44e6a0beb25","7843":"a7b035519c54d264","8787":"a1e3a7d3afb0d21c"}[chunkId] + ".css";
};